import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e35fad7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip-content" }
const _hoisted_2 = {
  key: 0,
  class: "tip-actions"
}

import { EditIcon } from '@zhuowenli/vue-feather-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'TipAlert',
  props: {
    small: { type: Boolean },
    dismissible: { type: Boolean }
  },
  emits: ["dismiss"],
  setup(__props: any, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["alert alert-tip with-icon tip-alert", { ['alert-sm']: _ctx.small, ['alert-dismiss']: _ctx.dismissible }]),
    role: "alert"
  }, [
    _createVNode(_unref(EditIcon), { size: "1.2x" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.dismissible)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn-close",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('dismiss')))
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})